/**
 * RailSelectCheckbox — per-child selection checkbox for the WHERE/HAVING Rail
 * wrap gesture (Slice 3B.5). Rendered by GroupRail before each child when an
 * editContext is present. Click toggles selection (shift-click extends the
 * run). HAVING parity (Plan 3 Task 5): `kind` (default `'where'`)
 * parameterizes the testid.
 */

import type { ReactElement } from 'react';
import type { BooleanClauseTarget } from '../../../../sql-resolver/types/structuralEdit';

export function RailSelectCheckbox({
  parentPath,
  index,
  checked,
  onToggle,
  kind = 'where',
}: {
  readonly parentPath: readonly number[];
  readonly index: number;
  readonly checked: boolean;
  readonly onToggle: (parentPath: readonly number[], index: number, shift: boolean) => void;
  readonly kind?: BooleanClauseTarget;
}): ReactElement {
  const childKey = [...parentPath, index].join('-') || 'root';
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={checked ? 'Deselect condition' : 'Select condition'}
      data-testid={`vqe-${kind}-rail-select-${childKey}`}
      className={`mt-1.5 h-3 w-3 flex-none rounded-sm border transition-colors ${
        checked ? 'border-primary bg-primary' : 'border-muted-foreground/40 hover:border-muted-foreground'
      }`}
      onClick={(e) => onToggle(parentPath, index, e.shiftKey)}
    />
  );
}
